export default function Tags({ taglist }) {
    return (
        <div className="tantraSec">
            {taglist?.map(tag => (
                <a href={`/search?keyword=${tag.meta_level3.replace('/', ' and ')}&type=all&lang=`} target="_blank">{tag.meta_level3}</a>
            ))}
        </div>
    );
}